export const csvToArray = (csv: string): string[] =>
  csv.split(',').map(item => item.trim());
